define('app/sdc/title/sdc-title',["$compile"], function ($compile) {
	var priority = 1;
	return {
		priority: priority,
		restrict: "AE",
		template: null,
		require: {
			"title": "^?sdc-title-controller.displayTitle"
		},
		controller: {},
		link: ["$self", "$element", "$scope", "$attrs", function (vm, $element, $scope, $attrs) {
			$attrs.$set("ngBind", "vm.title");
			$compile($element, null, priority)($scope);
		}]
	};
});
